import React, { Children } from 'react';
import PropTypes from 'prop-types';
import styles from './SelectListOption.css';
import classNames from 'classnames';

export default function asSelectListOption(WrappedComponent) {
  function SelectListOption(props) {
    const {
      selectListProps: {
        selected,
        value,
        onClick: onSelectListClick,
        onMouseOver: onSelectListMouseOver,
        highlight,
      } = {},
      onMouseOver,
      children,
      onClick,
      className,
      disabled,
    } = props;

    const selectListProps = {
      ...props,
      role: 'option',
      className: classNames(
        styles.selectListOption,
        className,
        highlight && styles.highlight,
        selected && styles.selected,
        disabled && styles.disabled
      ),
      onMouseOver(event) {
        if (disabled) {
          return;
        }
        event.target.value = String(value);
        onMouseOver && onMouseOver(event);
        onSelectListMouseOver &&
          !event.isPropagationStopped() &&
          onSelectListMouseOver(event);
      },
      onClick(event) {
        if (disabled) {
          return;
        }
        event.target.value = String(value);
        onClick && onClick(event);
        onSelectListClick &&
          !event.isPropagationStopped() &&
          onSelectListClick(event);
      },
    };

    // eslint-disable-next-line react/prop-types
    delete selectListProps.selectListProps;

    return (
      <WrappedComponent {...selectListProps}>
        {Children.map(children, child => {
          if (selected && React.isValidElement(child)) {
            return React.cloneElement(child, { selected });
          }

          return child;
        })}
      </WrappedComponent>
    );
  }

  SelectListOption.displayName = `asSelectListOption(${WrappedComponent.displayName ||
    WrappedComponent.name ||
    String(WrappedComponent)})`;
  SelectListOption.propTypes = {
    selectListProps: PropTypes.shape({
      selected: PropTypes.bool,
      value: PropTypes.any,
      highlight: PropTypes.bool,
      onMouseOver: PropTypes.func,
      onClick: PropTypes.func,
    }),
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    onMouseOver: PropTypes.func,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
  };

  return SelectListOption;
}
